import { z } from 'my-zod'
import { changeLogEntryModel } from './change-log-entry-model'

export const createChangeLogEntrySystemRequest = changeLogEntryModel.omit({
  id: true
})
export type createChangeLogEntrySystemRequest = z.infer<typeof createChangeLogEntrySystemRequest>
